import { render, staticRenderFns } from "./Cookies-cs.vue?vue&type=template&id=399fe984&"
import script from "./Cookies-cs.vue?vue&type=script&lang=js&"
export * from "./Cookies-cs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Projects\\Markomat-Client\\botaliberec-shop\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('399fe984')) {
      api.createRecord('399fe984', component.options)
    } else {
      api.reload('399fe984', component.options)
    }
    module.hot.accept("./Cookies-cs.vue?vue&type=template&id=399fe984&", function () {
      api.rerender('399fe984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cookies/Cookies-cs.vue"
export default component.exports